import script from "./TitleWithPlusIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleWithPlusIcon.vue?vue&type=script&lang=ts&setup=true"

import "./TitleWithPlusIcon.vue?vue&type=style&index=0&id=767ef313&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-767ef313"]])

export default __exports__